import React from "react";
import { getPublisherAvatarUrl } from "../../utils";
import {
  formatPostDate,
  getPlainExcerpt,
  getPostTypeLabel,
} from "./fourYearUtils";
import {
  FourYearAuthorLink,
  FourYearAuthorRow,
  FourYearCardBody,
  FourYearCardExcerpt,
  FourYearCardGrid,
  FourYearCardMedia,
  FourYearCardMediaGradient,
  FourYearCardOverlayLink,
  FourYearCardRoot,
  FourYearCardTitle,
  FourYearFeaturedBadge,
  FourYearMeta,
  FourYearMetaDate,
  FourYearTag,
  FourYearTags,
  FourYearTypePill,
} from "./FourYear.styles";

const typeIcon = (typeLabel) =>
  typeLabel === "Video" ? "play_circle" : "menu_book";

const FourYearCard = ({ post }) => {
  const imageUrl = post.image?.small || post.image?.original;
  const author = post.author || {};
  const excerpt = getPlainExcerpt(post.excerpt);
  const typeLabel = getPostTypeLabel(post);
  const tags = post.tags || [];
  const isFeaturedContributor = Boolean(author.isFeaturedContributor);

  return (
    <FourYearCardRoot>
      <FourYearCardGrid>
        <FourYearCardMedia>
          {imageUrl && <img src={imageUrl} alt="" loading="lazy" />}
          <FourYearCardMediaGradient aria-hidden="true" />
          <FourYearTypePill>
            <span className="material-icons" aria-hidden="true">
              {typeIcon(typeLabel)}
            </span>
            {typeLabel}
          </FourYearTypePill>
        </FourYearCardMedia>

        <FourYearCardBody>
          <FourYearAuthorRow>
            <FourYearAuthorLink
              to={`/analyst/${author.slug}`}
              onClick={(event) => event.stopPropagation()}
            >
              <img src={getPublisherAvatarUrl(author)} alt="" loading="lazy" />
              <div>
                <strong>{author.name}</strong>
                {author.title && <span>{author.title}</span>}
                {isFeaturedContributor && (
                  <FourYearFeaturedBadge>
                    Featured Contributor
                  </FourYearFeaturedBadge>
                )}
              </div>
            </FourYearAuthorLink>
          </FourYearAuthorRow>

          <FourYearCardTitle>{post.title}</FourYearCardTitle>
          {excerpt && <FourYearCardExcerpt>{excerpt}</FourYearCardExcerpt>}

          {tags.length > 0 && (
            <FourYearTags>
              {tags.slice(0, 4).map((tag) => (
                <FourYearTag key={tag.id || tag.name}>
                  #{tag.name}
                </FourYearTag>
              ))}
            </FourYearTags>
          )}

          <FourYearMeta>
            <FourYearMetaDate>
              <span className="material-icons" aria-hidden="true">
                event
              </span>
              {formatPostDate(post.publishedAt)}
            </FourYearMetaDate>
          </FourYearMeta>
        </FourYearCardBody>
      </FourYearCardGrid>

      <FourYearCardOverlayLink to={post.url}>
        <span>Read {post.title}</span>
      </FourYearCardOverlayLink>
    </FourYearCardRoot>
  );
};

export default FourYearCard;
